import {
  CommonSharedByType,
  mapCommonSharedByType,
} from "../../Share/CommonSharedByType";
import { mapShareContactTypes, ShareContactTypes } from "../ShareContactTypes";
import { mapSiteEmployeeTypes, SiteEmployeeType } from "./SiteEmployeeType";

export interface AttendanceProjectType {
  project_id?: number | null;
  job_number?: string;
  project_type?: string;
  description?: string;
  status?: string;
  user_id?: number;
  address?: string;
  post_code?: string;
  full_address?: string;
  is_own_project?: boolean;
  can_edit?: boolean;
  shared_by?: CommonSharedByType | null;
  contact?: ShareContactTypes[];
  share_list?: ShareContactTypes[];
  work_employee_list?: SiteEmployeeType[];
}

// to single object maping
export const mapAttendanceProjectType = (data: any): AttendanceProjectType => {
  if (!data) {
    throw new Error("Invalid Data");
  }
  const res: AttendanceProjectType = {
    project_id: data.project_id,
    job_number: data.job_number,
    project_type: data.project_type,
    description: data.description,
    status: data.status,
    user_id: data.user_id,
    address: data.address,
    post_code: data.post_code,
    full_address: data.full_address,
    is_own_project: data.is_own_project,
    can_edit: data.can_edit || false,
    shared_by: data.shared_by ? mapCommonSharedByType(data.shared_by) : null,
    contact: data.contact ? mapShareContactTypes(data.contact) : [],
    share_list: data.share_list ? mapShareContactTypes(data.share_list) : [],
    // work_employee_list:[]
    work_employee_list: data.work_employee_list ? mapSiteEmployeeTypes(data.work_employee_list) : [],
  };
  return res;
};

// maping list objects
export const mapAttendanceProjectTypes = (
  data: any[]
): AttendanceProjectType[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }
  return data.map(mapAttendanceProjectType);
};
